export const USER_TYPE = {
  ADMIN: 'admin',
  SERVICE_STATION: 'service station',
  SHIPPING_COMPANY: 'shipping company',
} as const;